/* ── Which script lines belong to which slide ──────────────────────────
   One source of truth, shared by the lesson page (slides beside the script)
   and the presentation (script beside the slides).

   Each pin says: slide `n` of deck `deck` belongs with the passage that
   contains the phrase `after`. The lines for a slide run from its passage
   up to the next slide's passage. Phrases are matched case-insensitively. */

export const LESSON_SLIDES = [
  { lesson: 'company', pins: [
    { after: '96% of contractors go out of business', deck: 'roof', n: 2, label: 'The problem with this industry' },
    { after: 'licensed in over 163 cities', deck: 'roof', n: 3, label: 'Licensed where you live — 163 cities' },
    { after: 'governing board is the CSLB', deck: 'roof', n: 4, label: 'Track record — CSLB, BBB, Edison' },
    { after: 'passed the five-year mark', deck: 'coat', n: 3, label: 'Q1 — How much experience do you have?' },
    { after: 'coverage per household', deck: 'coat', n: 5, label: 'Excellent track record' },
    { after: 'repeat customers', deck: 'coat', n: 5, label: 'Excellent track record' },
    { after: 'production manager', deck: 'coat', n: 4, label: 'Q2 — Who is assigned to my project?' },
  ]},
  { lesson: 'product demo', pins: [
    { after: 'explain all your options', deck: 'coat', n: 6, label: 'What options do you have?' },
    { after: 'First option is to do nothing', deck: 'coat', n: 7, label: 'Option 1 — Do nothing' },
    { after: 'Paint. These would be the second cheapest', deck: 'coat', n: 8, label: 'Option 2 — Paint' },
    { after: 'Complete restucco', deck: 'coat', n: 9, label: 'Option 3 — Re-stucco' },
    { after: 'called a color coat', deck: 'coat', n: 10, label: 'Option 4 — Color coat' },
    { after: 'vinyl siding', deck: 'coat', n: 11, label: 'Option 5 — Vinyl siding' },
    { after: 'Since 1961', deck: 'coat', n: 12, label: 'The ultimate option — COOLWALL®' },
    { after: 'McDonald', deck: 'coat', n: 13, label: 'Trusted by iconic brands' },
    { after: 'We trench approximately', deck: 'coat', n: 18, label: 'Step 1 — Trenching' },
    { after: 'We hydro blast', deck: 'coat', n: 20, label: 'Step 2 — Hydro-blast' },
    { after: 'THERMO BOND', deck: 'coat', n: 24, label: 'Step 4 — Recondition & repair' },
    { after: 'mask and tape off the entire home', deck: 'coat', n: 27, label: 'Step 6 — Masking & detail taping' },
    { after: 'we start with the primer coat', deck: 'coat', n: 29, label: 'Step 7 — The first coat of armor' },
  ]},
  { lesson: 'pricing', pins: [
    { after: 'Manufacturer\u2019s Suggested Retail Price', deck: 'coat', n: 33, label: 'What does the price include?' },
    { after: "Manufacturer's Suggested Retail Price", deck: 'coat', n: 33, label: 'What does the price include?' },
    { after: 'total of 25% off', deck: 'roof', n: 31, label: 'All-inclusive price policy' },
    { after: 'Tie-Down Question', deck: 'roof', n: 32, label: 'Financing options' },
  ]},
  { lesson: 'today', pins: [
    { after: 'quick recap', deck: 'coat', n: 34, label: 'TODAY — the five considerations' },
    { after: 'smart investment in', deck: 'roof', n: 33, label: 'TODAY — Company, Products, Protection, Representative, Investment' },
  ]},
  { lesson: 'intro', pins: [
    { after: 'here for our 10 o\u2019clock', deck: 'coat', n: 1, label: 'Opening slide' },
    { after: "here for our 10 o'clock", deck: 'coat', n: 1, label: 'Opening slide' },
  ]},
  { lesson: 'set the stage', pins: [
    { after: 'is it affordable', deck: 'coat', n: 34, label: 'TODAY — the five considerations' },
  ]},
];

/* ── Script for every slide (the Practice Room's SCRIPT drawer) ──────────
   Separate from LESSON_SLIDES above, which only places slide pictures inside
   the lesson pages. Each entry names the lesson and the passage that goes with
   one slide: from the paragraph containing `from` up to (not including) the
   paragraph containing `to`; `take` limits it to that many paragraphs.

   mode 'quoted' — lessons that put the words to say in "quotation marks"
                   (Company Story, Today's Page): only quoted paragraphs count.
   mode 'talk'   — lessons written as the talk track itself (Product Demo,
                   Pricing): every paragraph counts except headings.
   In both, a paragraph in (brackets) is a stage direction — shown as DO THIS. */

const OPENING    = [{ lesson: 'company story', mode: 'talk',   from: 'Before I talk about CPR', take: 1 },
                    { lesson: 'company story', mode: 'quoted', from: 'When you think about hiring a contractor', to: 'Page 1', showCues: true }];
const FIND_CO    = [{ lesson: 'company story', mode: 'quoted', from: 'When you think about hiring a contractor', to: 'Page 2' }];
const BUILT_LAST = [{ lesson: 'company story', mode: 'quoted', from: 'CPR was built to be the opposite', to: "We're a General B" }];
const CREWS_ROLE = [{ lesson: 'company story', mode: 'quoted', from: "We're a General B", to: 'Insurance & Bond' },
                    { lesson: 'company story', mode: 'quoted', from: 'I want to be clear about my role', to: 'A company story isn' }];
const PROTECTED  = [{ lesson: 'company story', mode: 'quoted', from: 'Insurance & Bond', to: 'I want to be clear about my role' }];
const PRICE_INTRO = [{ lesson: 'pricing', mode: 'talk', from: 'TIMELINE', to: 'How Our Pricing Works' }];
const PRICE_REST  = [{ lesson: 'pricing', mode: 'talk', from: 'How Our Pricing Works', to: null }];
const PRICE_ALL   = [{ lesson: 'pricing', mode: 'talk', from: 'TIMELINE', to: null }];
const TODAY       = [{ lesson: 'today', mode: 'quoted', from: 'quick recap', to: 'RULES FOR THIS PAGE' }];
/* Joe's teaching videos, shown under the script. Files live on the server in
   frontend/public/media/scripts/ (served at /media/scripts/). */
const VIDEO = (n) => `/media/scripts/slide-${n}.mp4`;
// Coating-only videos: from slide 6 on the decks differ, so Coating keeps its own folder
const COAT_VIDEO = (n) => `/media/scripts/coat/slide-${n}.mp4`;
// Windows-only videos (slides 6+)
const WIN_VIDEO = (n) => `/media/scripts/win/slide-${n}.mp4`;

const demo = (from, to, take) => [{ lesson: 'product demo', mode: 'talk', from, to, take }];

export const SLIDE_SCRIPTS = {
  coat: {
    1:  { label: 'Opening — what worries you the most?', parts: OPENING, video: VIDEO(1) },
    2:  { label: "Finding a dependable company isn't easy", parts: FIND_CO, video: VIDEO(2) },
    3:  { label: 'Q1 — How much experience do you have?', parts: BUILT_LAST, video: VIDEO(3) },
    4:  { label: 'Q2 — Who is assigned to my project?', parts: CREWS_ROLE, video: VIDEO(4) },
    5:  { label: 'Excellent track record', parts: PROTECTED, video: [VIDEO(5), COAT_VIDEO('5a')] },
    6:  { label: 'What options do you have?', parts: demo('explain all your options', '1. First option') },
    7:  { label: 'Option 1 — Do nothing', parts: demo('1. First option', '2. Paint'), video: COAT_VIDEO(7) },
    8:  { label: 'Option 2 — Paint', parts: demo('2. Paint', '3. Complete restucco'), video: COAT_VIDEO(8) },
    9:  { label: 'Option 3 — Re-stucco', parts: demo('3. Complete restucco', '4. Next is what'), video: COAT_VIDEO(9) },
    10: { label: 'Option 4 — Color coat', parts: demo('4. Next is what', '5. Last is vinyl'), video: COAT_VIDEO(10) },
    11: { label: 'Option 5 — Vinyl siding', parts: demo('5. Last is vinyl', '6. Final option'), video: COAT_VIDEO(11) },
    12: { label: 'The ultimate option — COOLWALL®', parts: demo('6. Final option', 'Over the decades'), video: COAT_VIDEO(12) },
    13: { label: 'Trusted by iconic brands', parts: demo('Over the decades', 'When billion-dollar companies'), video: COAT_VIDEO(13) },
    14: { label: 'Coated, not painted', parts: demo('When billion-dollar companies', null, 1) },
    15: { label: 'Built to stay that way', parts: demo("If it's strong enough", null, 1) },
    16: { label: 'Only the best preparation guarantees the best finish', parts: demo('Before we even talk about colors', null, 1) },
    17: { label: 'The root of the problem — below the soil line', parts: demo('The first step is addressing the source', 'OUR APPROACH'), video: COAT_VIDEO('17-18') },
    18: { label: 'Step 1 — Trenching', parts: demo('OUR APPROACH', 'HYDRO BLAST PITCH'), video: COAT_VIDEO('17-18') },
    19: { label: 'The second shortcut — painting over failure', parts: [...demo('how we remove all the loose paint', 'Before we even talk about colors'), ...demo('If we do not remove the old paint', 'WHAT WE DO -- HYDRO')], video: COAT_VIDEO('19-20') },
    20: { label: 'Step 2 — Hydro-blast', parts: demo('WHAT WE DO -- HYDRO', 'VISUAL PROOF'), video: COAT_VIDEO('19-20') },
    21: { label: 'Step 2 — Hydro-blast: nothing stays hidden', parts: demo('THIRD-PARTY STORY', 'FINAL REMINDERS') },
    22: { label: 'Step 3 — Power sand all wood surfaces', step: 'Process', parts: [], video: COAT_VIDEO(22) },
    23: { label: 'The third shortcut — coating over a crack', parts: demo('Now that we\u2019ve removed all the rotten', 'HOW WE DO IT (US)') },
    24: { label: 'Step 4 — Recondition, repair & refloat', parts: demo('HOW WE DO IT (US)', 'Sealing with FLEX PATCH'), video: COAT_VIDEO(24) },
    25: { label: 'Step 5 — Flex patch', parts: demo('Sealing with FLEX PATCH', 'TIPS FOR PRESENTATION'), video: COAT_VIDEO(25) },
    26: { label: 'The shortcut you will see every day — rushed masking', parts: demo('Unlike some painters who cut', null, 1), video: COAT_VIDEO('26-28') },
    27: { label: 'Step 6 — Masking & detail taping', parts: demo('MASKING AND TAPING', 'Masking may not be rocket science'), video: COAT_VIDEO('26-28') },
    28: { label: 'Step 6 — Masking done right', parts: demo('Masking may not be rocket science', null, 1), video: COAT_VIDEO('26-28') },
    29: { label: 'Step 7 — The first coat of armor (primer)', parts: demo('Primer Coat', 'Once the primer has fully dried'), video: COAT_VIDEO(29) },
    30: { label: 'Step 8 — The second coat of armor (finish)', parts: demo('Once the primer has fully dried', null), video: COAT_VIDEO(30) },
    33: { label: 'What does the price include?', parts: PRICE_ALL },
    34: { label: 'TODAY — the five considerations', parts: TODAY, video: COAT_VIDEO(34) },
  },
  roof: {
    1:  { label: 'Opening — what worries you the most?', parts: OPENING, video: VIDEO(1) },
    2:  { label: "Finding a dependable company isn't easy", parts: FIND_CO, video: VIDEO(2) },
    3:  { label: 'Licensed where you live', parts: BUILT_LAST, video: VIDEO(3) },
    4:  { label: 'Excellent track record', parts: PROTECTED, video: VIDEO(5) },
    5:  { label: 'Every step of the way', parts: [CREWS_ROLE[0]], video: VIDEO(4) },
    6:  { label: 'Quality support — your dedicated team', parts: [CREWS_ROLE[1]], video: VIDEO(4) },
    36: { label: 'What does the price include?', parts: PRICE_INTRO },
    37: { label: 'All-inclusive price policy', parts: PRICE_REST },
    39: { label: 'TODAY — the five considerations', parts: TODAY },
  },
  win: {
    1:  { label: 'Opening — what worries you the most?', parts: OPENING, video: VIDEO(1) },
    2:  { label: "Finding a dependable company isn't easy", parts: FIND_CO, video: VIDEO(2) },
    3:  { label: 'Q1 — How much experience do you have?', parts: BUILT_LAST, video: VIDEO(3) },
    4:  { label: 'Q2 — Who is assigned to my project?', parts: CREWS_ROLE, video: VIDEO(4) },
    5:  { label: 'Excellent track record', parts: PROTECTED, video: VIDEO(5) },
    6:  { label: "If you're thinking about replacing your windows", step: 'Windows', parts: [], video: WIN_VIDEO(6) },
    7:  { label: 'Problem — Infiltration', step: 'Windows', parts: [], video: WIN_VIDEO(7) },
    8:  { label: 'Problem — Conduction', step: 'Windows', parts: [], video: WIN_VIDEO(8) },
    9:  { label: 'Problem — Condensation & mold', step: 'Windows', parts: [], video: WIN_VIDEO(9) },
    10: { label: 'Problem — Radiation', step: 'Windows', parts: [], video: WIN_VIDEO(10) },
    11: { label: 'Problem — Monthly cost', step: 'Windows', parts: [], video: WIN_VIDEO(11) },
    12: { label: 'Problem — Security', step: 'Windows', parts: [], video: WIN_VIDEO(12) },
    13: { label: 'Which of these apply to you?', step: 'Windows', parts: [], video: WIN_VIDEO(13) },
    15: { label: 'Frame — which material meets your needs?', step: 'Windows', parts: [], video: WIN_VIDEO(15) },
    16: { label: 'Installation — new construction', step: 'Windows', parts: [], video: WIN_VIDEO(16) },
    17: { label: 'Installation — retro-fit', step: 'Windows', parts: [], video: WIN_VIDEO(17) },
    18: { label: 'Installation — professional', step: 'Windows', parts: [], video: WIN_VIDEO(18) },
    30: { label: 'What does the price include?', parts: PRICE_INTRO },
    31: { label: 'All-inclusive price policy', parts: PRICE_REST },
    33: { label: 'TODAY — the five considerations', parts: TODAY },
  },
};

/* Lines introduced as examples ("for example", "they might say") are what
   the homeowner says, not the rep — leave them out of the rep's script. */
const EXAMPLE_CUE = /(for example|for instance|they might say|they may say|homeowner says|customer says|you might hear|expected response)/i;

const STEP_FOR = {
  'set the stage': 'Step 3 — Set the Stage', 'company story': 'Step 4 — Company Story',
  'product demo': 'Step 5 — Product Demo', 'pricing': 'Step 6 — Pricing & Timeline', 'today': "Step 7 — Today's Page",
};

const norm = (s) => String(s).replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"').toLowerCase();
const oneLine = (s) => String(s).replace(/\s*\n\s*/g, ' ').replace(/\s{2,}/g, ' ').trim();

/* A line that is a heading, not something to say: ALL CAPS, a short label with
   no sentence punctuation ("Primer Coat", "Since 1961"), or "Script:" style tags. */
function isHeading(line) {
  const t = String(line).trim();
  if (!t) return true;
  if (/[A-Za-z]/.test(t) && !/[a-z]/.test(t)) return true;
  if (/^[\u2022o\u00B7\-\u2013>\u2192\d]/.test(t) || /^["\u201C'(]/.test(t)) return false;
  const words = t.split(/\s+/).length;
  if (/:$/.test(t) && words <= 3) return true;
  if (words <= 7 && !/[.?!:"\u201D'\u2026,)]$/.test(t)) return true;
  // Title Case label, e.g. "Same-Day Decision Discount (Why It Exists)"
  const small = /^(a|an|and|the|of|to|for|in|on|or|it|is|&|-|\u2014)$/i;
  return words <= 8 && !/[.?!:"\u201D,\u2026]$/.test(t) && t.split(/\s+/).every(w => small.test(w) || /^[A-Z(0-9]/.test(w));
}

/* How many double quote marks a paragraph has — odd means a quote opens
   (or closes) here and carries on into the next paragraph. */
const quoteMarks = (t) => (String(t).match(/["\u201C\u201D]/g) || []).length + (/^\s*'/.test(t) ? 1 : 0);  // 'Hopefully ..." opens with a single mark

/* Paragraph text → { t, kind } or null.  kind: 'say' | 'do'
   `inQuote` = this paragraph continues a quote opened earlier. */
function readPara(raw, mode, inQuote, cues) {
  let lines = String(raw).split('\n').map(l => l.trim()).filter(Boolean);
  if (!inQuote) while (lines.length && isHeading(lines[0])) lines.shift();   // leading headings
  while (lines.length > 1 && (/[A-Za-z]/.test(lines[lines.length - 1]) && !/[a-z]/.test(lines[lines.length - 1])
         || /^[A-Za-z ]{2,30}:$/.test(lines[lines.length - 1]))) lines.pop();   // trailing heading / "Expected response:" label
  if (!lines.length) return [];
  // a line in (brackets) is a stage direction: its own DO entry
  const out = []; let buf = [];
  const flush = () => {
    if (!buf.length) return;
    let t = oneLine(buf.join('\n')).replace(/^intro\s*:\s*/i, '');
    buf = [];
    if (!t || /^\d+\.?$/.test(t)) return;                              // a lone "2." left by the page layout
    if (/^\u2022\s*>/.test(t)) { if (cues) out.push({ t: t.replace(/^\u2022\s*>\s*/, ''), kind: 'do' }); return; }  // "• > Let them answer" = instruction
    if (/^\u2192/.test(t)) return;                                 // coaching marks
    if (!inQuote && !out.length && mode === 'quoted' && !/^["\u201C']/.test(t)) return;
    out.push({ t, kind: 'say' });
  };
  lines.forEach(l => {
    if (/^\(.*\)\.?$/.test(l)) { flush(); out.push({ t: l, kind: 'do' }); }
    else buf.push(l);
  });
  flush();
  return out;
}

function passage(content, part) {
  const paras = String(content).split(/\n\s*\n/);
  const low = paras.map(norm);
  const start = low.findIndex(p => p.includes(norm(part.from)));
  if (start < 0) return [];
  let end = paras.length, endCut = null;
  if (part.to) {
    const e = low.findIndex((p, i) => i >= start && p.includes(norm(part.to)) && !(i === start && p.indexOf(norm(part.to)) < p.indexOf(norm(part.from))));
    if (e >= 0) { end = e + 1; endCut = e; }
  }
  if (part.take) end = Math.min(end, start + part.take);

  const out = [];
  let inQuote = false;
  for (let i = start; i < end; i++) {
    let lines = paras[i].split('\n');
    // start at the line holding the 'from' phrase; stop before the line holding the 'to' phrase
    if (i === start) { const k = lines.findIndex(l => norm(l).includes(norm(part.from))); if (k > 0) lines = lines.slice(k); }
    if (i === endCut) { const k = lines.findIndex(l => norm(l).includes(norm(part.to))); lines = k >= 0 ? lines.slice(0, k) : []; }
    const text = lines.join('\n');
    if (!text.trim()) continue;
    const wasIn = inQuote;
    const got = readPara(text, part.mode, wasIn, part.showCues);
    if (part.mode === 'quoted') {
      if (wasIn || got.some(r => r.kind === 'say')) inQuote = (quoteMarks(text) % 2 === 1) ? !wasIn : wasIn;
    }
    if (!got.length) continue;
    if (part.mode === 'quoted' && !wasIn && i > 0 && EXAMPLE_CUE.test(paras[i - 1])) continue;
    got.forEach((r, j) => {
      const prev = out[out.length - 1];
      const joinable = prev && prev.kind === 'say' && r.kind === 'say';
      if (joinable && j === 0 && wasIn) { prev.t += ' ' + r.t; return; }                       // same quote, carried over
      if (joinable && /^[\u2022o]\s/.test(r.t) && /(:|[\u2022o]\s[^\u2022]*)$/.test(prev.t) && /:|\s[\u2022o]\s/.test(prev.t)) { prev.t += '  ' + r.t; return; } // rest of a bullet list
      if (joinable && !/[.?!:"\u201D)\u2026]$/.test(prev.t) && /^[a-z]/.test(r.t)) { prev.t += ' ' + r.t; return; }  // sentence broken by a stray blank line
      out.push(r);
    });
  }
  return out;
}

/**
 * Script for every slide of one deck, from the live lesson text.
 *   deck    — 'coat' | 'roof' | 'win'
 *   lessons — [{ id, title, content, stepTitle, order }]
 * Returns   — { steps, bySlide: { [n]: { stepKey, stepTitle, label, lines: [{t, kind}] } } }
 */
export function buildDeckScripts(deck, lessons) {
  const map = SLIDE_SCRIPTS[deck] || {};
  const find = (key) => lessons.find(l => norm(l.title || '').includes(key) || norm(l.stepTitle || '').includes(key));
  const bySlide = {};
  Object.keys(map).map(Number).sort((a, b) => a - b).forEach(n => {
    const def = map[n];
    const lines = [];
    let stepTitle = '', stepKey = '';
    def.parts.forEach(part => {
      const lesson = find(part.lesson);
      if (!lesson || !lesson.content) return;
      if (!stepKey) { stepKey = 'l' + lesson.id; stepTitle = STEP_FOR[part.lesson] || lesson.stepTitle || lesson.title; }
      lines.push(...passage(lesson.content, part));
    });
    if (lines.some(l => l.kind === 'say') || def.video) bySlide[n] = { stepKey, stepTitle: stepTitle || def.step || '', label: def.label, lines, video: def.video || null };
  });
  return { steps: [], bySlide };
}
